import ExamImage from "../components/ExamImage";
import QuestionLayout from "./QuestionLayout";
import DiagramNumberInput from "./NumberInput";

export default function DiagramLabelingWidget({
  id,
  config,
  value = {},
  onChange,
  mode,
  feedback
}) {
  function setAnswer(targetId, v) {
    onChange({
      ...value,
      [targetId]: v
    });
  }

  function partFeedback(targetId) {
    return feedback?.parts?.find(p => p.id === targetId);
  }

  const [W, H] = config.aspectRatio.split("/").map(Number);

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      legendImage={config.legendImage}
      mode={mode}
      feedback={feedback}
    >
      {/* WIDTH CONSTRAINER */}
      <div
        style={{
          maxWidth: config.maxWidth
            ? `${config.maxWidth}px`
            : "100%",
          margin: "0 auto" // optional centering
        }}
      >
        {/* RATIO LOCK */}
        <div
          style={{
            position: "relative",
            width: "100%",
            aspectRatio: config.aspectRatio
          }}
        >
          <ExamImage
            src={config.image}
            alt="Diagram"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
              pointerEvents: "none"
            }}
          />

          {config.targets.map(t => {
            const fb = partFeedback(t.id);
            const tx = (t.id.indexOf("b")==-1) ? t.x : t.x - 13.6;
            const ty = (t.id.indexOf("b")==-1) ? t.y : t.y + 43;

            return (
              <div
                key={t.id}
                style={{
                  position: "absolute",
                  left: `${(tx / W) * 100}%`,
                  top: `${(ty / H) * 100}%`,
                  transform: "translate(-50%, -50%)"
                }}
              >
                <DiagramNumberInput
                  value={value[t.id] ?? ""}
                  cid={t.id}
                  onChange={v => setAnswer(t.id, v)}
                  disabled={mode !== "edit"}
                  accidentalsRight={t.accidentalsRight}  // ← per target
                  allowAccidentals={config.allowAccidentals}
                  normalizeCase={t.normalizeCase ?? config.normalizeCase ?? "upper"}
                  border={
                    mode === "review"
                      ? fb?.correct
                        ? "correct"
                        : "incorrect"
                      : "default"
                  }
                />
              </div>
            );
          })}
        </div>
      </div>
    </QuestionLayout>
  );
}
